import styled from 'styled-components';

export const Header = styled.h3`
  color: var(--pd-dark-text-color);
  font-weight: bold;
  user-select: text;
  display: flex;
  justify-content: space-between;
`;
